import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useCallback } from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { Button } from '../Button/Button.js';
import style from './SelectButton.module.css.js';

const SelectButtonItem = ({ title, subtitle, selected, disabled, onClick, className, ...attrs }) => {
    const handleOnClick = useCallback(() => {
        if (!disabled) {
            onClick?.();
        }
    }, [disabled, onClick]);
    return (jsx("div", { className: classNames(style.item, selected && style.selected, disabled && style.disabled, className), onClick: handleOnClick, role: "button", ...attrs, children: jsxs("div", { className: style.itemContent, children: [jsx("div", { className: style.title, children: title }), subtitle && jsx("div", { className: style.subtitle, children: subtitle })] }) }));
};
const SelectButton = ({ type, value, onChange, size, children, disabled, className, }) => {
    const onSelectItem = useCallback((val) => {
        if (type === "checkbox") {
            if (value?.includes(val)) {
                onChange?.(value?.filter((v) => v !== val));
            }
            else {
                onChange?.([...(value || []), val]);
            }
        }
        else {
            onChange?.(val);
        }
    }, [onChange, value, type]);
    const handleItemClicked = useCallback((val) => {
        if (!disabled) {
            onSelectItem(val);
        }
    }, [disabled, onSelectItem]);
    return (jsx("div", { className: classNames(style.wrapper, disabled && style.disabled, size === "small" && style.small, className), children: React__default.Children.map(children, (child) => {
            if (child && React__default.isValidElement(child)) {
                if ((child.props?.size ?? size) === "small") {
                    return (jsx(Button, { ...child.props, variant: "grayscale", className: classNames(value?.includes(child.props.value) && style.selected, style.button), disabled: child.props.disabled, onClick: () => handleItemClicked(child.props.value), children: child.props.title }));
                }
                return (jsx(SelectButtonItem, { ...child.props, selected: value?.includes(child.props.value), disabled: child.props.disabled, onClick: () => handleItemClicked(child.props.value) }));
            }
        }) }));
};
SelectButton.Item = SelectButtonItem;
SelectButtonItem.displayName = "SelectButtonItem";

export { SelectButton };
//# sourceMappingURL=SelectButton.js.map
